import script from "./PasswordReset.vue?vue&type=script&setup=true&lang=js"
export * from "./PasswordReset.vue?vue&type=script&setup=true&lang=js"

import "./PasswordReset.vue?vue&type=style&index=0&id=612b965a&lang=css"

const __exports__ = script;

export default __exports__